import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Home/components/Statistics/Statistics.module.scss';

const cn = classNames.bind(styles);

interface StatisticsProps {
  membersQuantity: number | string;
}

const Statistics: FC<StatisticsProps> = ({ membersQuantity }): ReactElement => {
  return (
    <div className={cn('statistics')}>
      <div className={cn('statistics__container')}>
        <div className={cn('statistics__number')}>{membersQuantity}</div>
        <p className={cn('statistics__text')}>members</p>
      </div>
      <div className={cn('statistics__container')}>
        <p className={cn('statistics__number')}>190+</p>
        <p className={cn('statistics__text')}>countries</p>
      </div>
    </div>
  );
};

export { Statistics };
